module.exports = __webpack_public_path__ + "static/media/Stanleybet_logo_international1.0e45fbde.svg";